import { LabeledChipAppearance } from '@components/v2/ui/LabeledChip/labeledChip.styles';
import DynamicTagsAdapter from '../tags/DynamicTags/DynamicTagsAdapter';
import { ProductTag } from './hooks/useGetProductTagGroups';
import SelloutProductTag from './product-cells/SelloutProductTag';
import SuggestedProductTag from './product-cells/SuggestedProductTag';

interface ProductTagsRendererProps {
  tags: ProductTag[] | null;
  variant?: LabeledChipAppearance;
  useSuffix?: boolean;
}

const ProductTagsRenderer = ({ tags, variant, useSuffix = false }: ProductTagsRendererProps) => {
  if (!tags || !tags.length) {
    return null;
  }

  return (
    <>
      {tags.map((tag) => {
        switch (tag.type) {
          case 'colorClassification':
            return <DynamicTagsAdapter key={tag.type} tags={tag.props?.tags!} variant={variant} />;

          case 'suggested':
            return <SuggestedProductTag key={tag.type} variant={variant} useSuffix={useSuffix} />;

          case 'sellout':
            return (
              <SelloutProductTag
                key={tag.type}
                variant={variant}
                quantity={tag.props?.quantity || 0}
                useSuffix={useSuffix}
              />
            );

          default:
            return null;
        }
      })}
    </>
  );
};

export default ProductTagsRenderer;
